export const SET_USER = 'SET_USER';
export const SET_ERROR_FORGOT = 'SET_ERROR_FORGOT';